/* 🤖 this file was generated by svg-to-ts */
export const iccIconRemove: {
  name: 'remove';
  data: string;
} = {
  name: 'remove',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M19 13H5v-2h14v2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></svg>`
};
